import L from 'leaflet'
import 'leaflet-routing-machine'
import 'lrm-graphhopper'

function lineStyle(color) {
  return {
    color,
    opacity: 0.6,
    weight: 4
  }
}

export function addRouting({
  color,
  routeStops,
  mapRef,
  graphHopperApiKey,
  routingElement = null,
  fitBounds = true,
  hideStopPins = false,
  markers = null,
  showLinesBetweenRoutes = true
}) {
  let routeStopCoordinates = []

  if (!routeStops) {
    return
  }

  if (fitBounds) {
    mapRef.fitBounds(routeStops.map(stop => stop.coordinates))
  }

  routeStopCoordinates = routeStops.map(stop => L.latLng(...stop.coordinates))

  if (routingElement) {
    routingElement.setWaypoints(routeStopCoordinates)

    return routingElement
  }

  let leafletElement = L.Routing.control({
    plan: L.Routing.plan(routeStopCoordinates, {
      routeWhileDragging: false,
      createMarker: function (i, wp, nWps) {
        const homePin = `<i class="fa-solid fa-house" style="color: ${color};position: absolute;left: -0.5rem;top: -0.8rem;"></i>`
        const overlapPin = `
          <span class="fa-stack">
            <span class="fa-solid fa-user-group fa-xl" style="color: ${color}"></span>
          </span>
        `
        const stopPin = position => `
          <span class="fa-stack" style='position: absolute;left: -0.5rem;top: -0.8rem;'>
            <span class="fa-solid fa-location-pin fa-stack-2x" style="color: ${color}"></span>
            <span class="fa-stack-1x text-white">${position}</span>
          </span>
        `

        let html = ''
        if (i === 0) {
          html = homePin
        } else if (!hideStopPins && routeStops[i] && routeStops[i]['overlap']) {
          html = overlapPin
        } else if (!hideStopPins && i !== nWps.length - 1 && routeStops[i] && routeStops[i]['position']) {
          html = stopPin(routeStops[i]['position'])
        }

        const icon = L.divIcon({ html })

        const marker = L.marker(wp.latLng, { icon })

        // Setting up the popup for each route stop marker
        if (routeStops[i]) {
          let popupContent = null
          if (routeStops[i]['overlap']) {
            popupContent = routeStops[i]['popup_content_for_overlap'].replace(/,/g, '<br/>')
          } else {
            popupContent = routeStops[i]['name']
          }

          marker.bindPopup(popupContent, { offset: [0, -10] })
        }

        // Clustering
        if (markers) {
          markers.addLayer(marker)
        } else {
          return marker
        }
      }
    }),
    autoRoute: showLinesBetweenRoutes,
    lineOptions: {
      styles: showLinesBetweenRoutes ? [lineStyle(color)] : []
    },
    router: L.Routing.graphHopper(graphHopperApiKey),
    addWaypoints: false,
    draggableWaypoints: false,
    fitSelectedRoutes: false,
    showAlternatives: false
  })

  leafletElement.addTo(mapRef)

  return leafletElement
}
